import { Anchor, Checkbox, Text } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { WEBSITE_URL } from "../../../constants/url";
import type { ReactNode } from "react";
import type { Locale } from "@project/common";
import type { CheckboxProps } from "@mantine/core";

export const privacyPolicyURL = (locale: Locale) => locale == "en" ? `${WEBSITE_URL}/privacy` : `${WEBSITE_URL}/${locale}/privacy`;
export const termsOfServiceURL = (locale: Locale) => locale == "en" ? `${WEBSITE_URL}/terms` : `${WEBSITE_URL}/${locale}/terms`;

interface TermsConditionsCheckboxProps extends CheckboxProps {
  locale: Locale;
}

export function TermsConditionsCheckbox(props: TermsConditionsCheckboxProps) {
  return (
    <Checkbox
      required
      pt="xs"
      label={(
        <Text size="sm" component="span">
          <FormattedMessage
            id="text.termsAndConditions"
            defaultMessage="I agree to Mapka's <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>"
            values={{
              termsLink: (chunks: ReactNode) => (
                <Anchor underline="always" href={termsOfServiceURL(props.locale)} target="_blank" rel="noopener noreferrer">
                  {chunks}
                </Anchor>
              ),
              privacyLink: (chunks: ReactNode) => (
                <Anchor underline="always" href={privacyPolicyURL(props.locale)} target="_blank" rel="noopener noreferrer">
                  {chunks}
                </Anchor>
              ),
            }}
          />
        </Text>
      )}
      {...props}
    />
  );
}
